import {
  AfterViewInit,
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { BehaviorSubject } from 'rxjs';
import { UserRole } from '@reenstudio/app/core/enum/user-role';

@Component({
  selector: 'app-abstract-list',
  templateUrl: './abstract-list.component.html',
  styleUrls: ['./abstract-list.component.scss'],
  standalone: true,
})
export abstract class AbstractListComponent
  implements OnInit, AfterViewInit, OnChanges
{
  @Input() pagination = false;
  @Input() displayedColumns: string[] = [];
  @Input() reload: number = 0;
  @Input() filters: any;
  @Input() role: UserRole;

  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;

  loading = new BehaviorSubject<boolean>(true);
  dataLength = 0;
  dataTable: MatTableDataSource<any>;
  filterChanged = new BehaviorSubject<number>(0);

  protected constructor() {
    this.dataTable = new MatTableDataSource<any>([]);
  }

  ngAfterViewInit(): void {
    this.dataTable.paginator = this.paginator;
    this.dataTable.sort = this.sort;
  }

  ngOnInit(): void {
    this.getList();
    this.setTableColumns();
  }

  hidePagination() {
    return !this.pagination || this.loading.value || !this.dataLength;
  }

  hideData() {
    return this.loading.value || !this.dataLength;
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.triggerFilterChange();
  }

  protected abstract getList(): void;
  protected setTableColumns(): void {
    // if (this.role === UserRole.CER) {
    //   this.displayedColumn.unshift('plant');
    // }
  }

  protected triggerFilterChange() {
    this.filterChanged.next(this.filterChanged.value + 1);
  }
}
